import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import './LabRequestForms.css';
import { fetchUserEdgeData, fetchFormData, saveLabRequestMetaDoc } from '../../../services/hih/Service';
import axios from "axios";
import Select from 'react-select';
import moment from 'moment';
import { MultiSelect } from 'react-multi-select-component';
import { formatDateTime } from '../../met/utils/CommonLibrary';
import DatePicker from 'react-datepicker';
import { getWAMessageDetails } from '../../utils/Utils';
import LocationDisplay from '../../cn/components/OCRDocument/LocationDisplay';

const LabRequestMetaDocForms = ({ closeModal, selectedServiceRecord, callHomeBasedServicesHistory, memberBasicInfo, aiBupaServiceRecommendations, getAiBupaServiceRecommendations, handleFamilyMemberProfileClick }) => {


    const userId = memberBasicInfo.userId;
    const labRecommendationIds = aiBupaServiceRecommendations[0]?.labs
        ?.map(lab => lab.recommendationId)
        ?.join(',');

    let aiBupaLabTests = "";
    let aiBupaLabTestsArray = [];
    let aiBupaLabTestsArrayInternal = [];

    if (
        Array.isArray(aiBupaServiceRecommendations) &&
        aiBupaServiceRecommendations[0]?.labs?.length > 0
    ) {
        const matchedLabs = aiBupaServiceRecommendations[0].labs
            .filter((item) => item.matchFound === 'Y')
            .map((item) => {
                const value = `${item.value || ''}__${item.label || ''}__${item.productId || ''}`;
                const label = `${item.value || ''} ${item.label || ''}`;
                const loincCode = item.value;
                const metadocLabName = item.label;
                const dataSource = item.dataSource;

                aiBupaLabTestsArrayInternal.push({
                    value,
                    label,
                    loincCode,
                    metadocLabName,
                    dataSource,
                });

                return value;
            });

        aiBupaLabTests = matchedLabs.join(',,');

        console.log("matchedLabs:", matchedLabs);
        console.log("aiBupaLabTestsArrayInternal:", aiBupaLabTests, aiBupaLabTestsArrayInternal);
    }


    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [labProviderList, setLabProviderList] = useState([]);
    const [partner, setPartner] = useState([]);
    const [disabledButton, setDisabledButton] = useState(true);
    const [cityList, setCityList] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const [recommendationsList, setRecommendationsList] = useState([]);
    const [selectedRecommendation, setSelectedRecommendation] = useState([]);
    const [showOcr, setShowOcr] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const [formData, setFormData] = useState({
        userId: userId,
        selectedServiceRecord: selectedServiceRecord,
        membership: '',
        name: '',
        approvalNumber: '',
        mobileNumber: '',
        deductible: '',
        partnerClinic: '',
        labProvider: '',
        labProviderName: '',
        city: '',
        district: '',
        remarks: '',
        requestedLabTest: aiBupaLabTests,
        nationality: '',
        selectedUserNames: aiBupaLabTests,
        aiBupaLabTestsArray: [],
        address: '',
        selectedDate: '',
        viewDate: '',
        cityId: '',
        coPayment: '',
        recommendationIds: labRecommendationIds,
        mediaUrl: '',
        address: '',
        latitude: '',
        longitude: '',
        imageUrl: '',
        addressType: '',
        preferredTime: '',
        flowId: '',
        memberRequestId: '',
        productCount: 0
    });

    useEffect(() => {
        fetchUserData();
        dropdownData();
        handleChangeService(aiBupaLabTestsArrayInternal);
    }, [])

    const fetchUserData = async () => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        setDisabledButton(true);
        await fetchUserEdgeData(userId, 'metaService-hbl')
            .then((response) => {
                if (response.data.code === 200) {
                    setFormData((prev) => ({
                        ...prev, membership: memberBasicInfo.membershipNumber, name: memberBasicInfo.memberName, mobileNumber: memberBasicInfo.mobile, nationality: response.data.data.info.nationality,
                        address: response.data.data.info.address, mediaUrl: response.data.data.info.mediaUrl, cityId: response.data.data.info.cityId, city: response.data.data.info.cityName,
                        addressType: response.data.data.info.addressType, preferredTime: response.data.data.info.preferredTime, address: response.data.data.info.address, latitude: response.data.data.info.latitude,
                        longitude: response.data.data.info.longitude, imageUrl: response.data.data.info.imageUrl, flowId: response.data.data.info.flowId, memberRequestId: response.data.data.info.memberRequestId
                    }));

                    if (response.data.data.info.hasOwnProperty('preferredTime') && response.data.data.info.preferredTime != "") {
                        setFormData((prev) => ({
                            ...prev, viewDate: new Date(response.data.data.info.preferredTime), selectedDate: formatDateTime(new Date(response.data.data.info.preferredTime))
                        }));
                    }

                    setShowOcr(response.data.data.info.showOcr);
                    if (response.data.data.info.cityId > 0) {
                        fetchCategoryList(response.data.data.info.cityId);
                    }
                    setDisabledButton(false);
                } else {
                    setError(response.data.data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }

    const dropdownData = async () => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await fetchFormData('', memberBasicInfo.membershipNumber)
            .then((response) => {
                if (response.data.code === 200) {
                    setPartner(response.data.data.partner);
                    setCityList(response.data.data.city);
                    setServiceList(response.data.data.labTest);
                    setRecommendationsList(response.data.data.recommendations);
                } else {
                    setError(response.data.data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }


    const handleChange = async (e) => {
        const { name, value } = e.target;

        // Special handling for coPayment
        if (name === "coPayment") {
            const updatedFormData = { ...formData, [name]: value };

            // If coPayment is 'no', set deductible to 'NILL'
            if (value === 'no') {
                updatedFormData.deductible = 'NIL';
            } else {
                // If changing from 'no' to 'yes', reset deductible to empty
                if (formData.coPayment === 'no') {
                    updatedFormData.deductible = '';
                }
            }

            setFormData(updatedFormData);
            return;
        }

        // Prevent deductible changes if coPayment is 'no'
        if (name === "deductible" && formData.coPayment === 'no') {
            return;
        }

        // Existing handle change logic for other fields
        const updatedFormData = { ...formData, [name]: value };
        if (name === "labProvider") {
            updatedFormData.labProviderName = e.target.selectedOptions[0].text;
        }
        setFormData(updatedFormData);
        setError('');
    };

    const handleRecommendationChange = async (e) => {
        const index = e.target.value;
        setSelectedRecommendation(index);

        if (index === "" || !recommendationsList[index] || !recommendationsList[index].services) {
            setSelectedOptions([]);
            setFormData((prevData) => ({
                ...prevData,
                requestedLabTest: "",
                selectedUserNames: "",
                productCount: 0
            }));
            return;
        }
        setSelectedOptions(recommendationsList[index].services);

        const selectedValues = recommendationsList[index].services.map(option => option.value).join(',,');
        setFormData((prevData) => ({
            ...prevData,
            requestedLabTest: selectedValues,
            selectedUserNames: selectedValues,
            productCount: recommendationsList[index].services.length
        }));
    };

    const validateForm = () => {
        const mandatoryFields = ['membership', 'name', 'mobileNumber', 'deductible', 'partnerClinic', 'labProvider', 'city', 'requestedLabTest', 'nationality', 'selectedDate', 'coPayment'];

        for (let field of mandatoryFields) {
            if ((field === 'city')) {
                if (formData[field] == "") {
                    setError('Enter all mandatory fields');
                    return false;
                }
            } else if (field === 'selectedDate') {
                if (formData[field] == "" || formData[field] == undefined) {
                    setError('Enter all mandatory fields');
                    return false;
                }
            } else if (!formData[field].trim()) {
                setError('Enter all mandatory fields');
                return false;
            }
        }

        return true;
    };

    const setSelctedDate = async (date) => {
        setFormData({
            ...formData,
            ['viewDate']: date,
            ['selectedDate']: formatDateTime(date),
        });

        setError('');
    };

    const handleChangeCity = (selectedOption) => {
        fetchCategoryList(selectedOption.value);
        setFormData({
            ...formData,
            ['city']: selectedOption.label,
            ['cityId']: selectedOption.value,
        });
    };

    const fetchCategoryList = async (cityName) => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await fetchFormData(cityName, formData['membership'])
            .then((response) => {
                if (response.data.code === 200) {
                    setLabProviderList(response.data.data.lab);
                } else {
                    setError(response.data.data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }

    const handleSubmit = async (event) => {

        setError('');
        event.preventDefault();
        if (validateForm()) {
            const request = axios.CancelToken.source();
            let ct = {
                cancelToken: request.token
            }
            setDisabledButton(true);
            await saveLabRequestMetaDoc(formData)
                .then((response) => {
                    if (response.data.code === 200) {
                        setMessage(response.data.data.message);
                        //callHomeBasedServicesHistory();
                        getAiBupaServiceRecommendations(memberBasicInfo.membershipNumber);
                        handleFamilyMemberProfileClick(memberBasicInfo.membershipNumber);
                        setTimeout(() => {
                            closeModal();
                        }, 1000);
                    } else {
                        setMessage('');
                        setError(response.data.data.message);
                        setDisabledButton(false);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            return () => request.cancel();
        }
    }

    const handleChangeService = (selected) => {
        const matchedProducts = selected?.map((selectedItem) => {
            const foundProduct = aiBupaLabTestsArrayInternal.find(
                (item) => item.value === selectedItem.value
            );

            // If found, return it; otherwise return the fallback object
            return (
                foundProduct || {
                    value: selectedItem.value,
                    label: selectedItem.label,
                    loincCode: selectedItem.value?.split('__')[0] || '',
                    metadocLabName: selectedItem.value?.split('__')[1] || '',
                    dataSource: 'manual',
                }
            );
        });

        setSelectedOptions(selected);
        const selectedValues = selected.map(option => option.value).join(',');
        const selectedValuesNew = selected.map(option => option.value).join(',,');
        setFormData({ ...formData, requestedLabTest: selectedValues, selectedUserNames: selectedValuesNew, aiBupaLabTestsArray: matchedProducts, productCount: selected.length });
    };
    const selectedUserNamesTemp = selectedOptions.map(option => option.label).join(', ');

    const filterPassedTime = (time) => {
        const currentDate = new Date();
        const selectedTime = new Date(time);

        // Allow only times equal to or greater than the current time for today
        return selectedTime.getTime() >= currentDate.getTime();
    };

    useEffect(() => {
        if (formData['viewDate']) {
            const now = new Date();
            if (formData['viewDate'] < now) {
                const roundedNow = roundToNext15Minutes(now);
                // setSelectedDate(roundedNow);
                setFormData({
                    ...formData,
                    ['viewDate']: roundedNow,
                    ['selectedDate']: formatDateTime(roundedNow),
                });
            }
        }
    }, [formData['viewDate']]);

    const roundToNext15Minutes = (date) => {
        const roundedDate = new Date(date);
        const minutes = roundedDate.getMinutes();
        const remainder = 15 - (minutes % 15);
        roundedDate.setMinutes(minutes + remainder);
        roundedDate.setSeconds(0);
        roundedDate.setMilliseconds(0);
        return roundedDate;
    };

    const handleImageClick = (url) => {
        window.open(url, '_blank');
        setIsDropdownOpen(false);
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    return (
        <>
            <div className='col-md-12'>
                <div className='card card-task-appoint'>
                    <div className='card-body'>
                        <div className='card-text'>
                            <form id="medicationForm" onSubmit={handleSubmit} style={{ width: "100%" }}>
                                <div className="tw-flex tw-items-start tw-w-full tw-gap-4">
                                    {(aiBupaServiceRecommendations[0]?.labs?.filter(item => item.matchFound === 'N')?.length > 0 ||
                                        (formData.addressType && formData.address)) && (

                                            <div className="tw-flex-grow profile-box-n1 tw-flex tw-flex-row tw-items-center tw-gap-4">
                                                {aiBupaServiceRecommendations[0]?.labs?.filter(item => item.matchFound === 'N')?.length > 0 &&
                                                    <div className='tw-flex tw-flex-col tw-items-start tw-gap-2 mb-1'>
                                                        <div className="tw-flex tw-items-center tw-gap-2 mb-1">
                                                            <span className='fw-semibold tw-text-lg'>Recommended Lab Requests :</span>
                                                            <span>{getWAMessageDetails(aiBupaServiceRecommendations?.[0]?.labs)}</span>
                                                        </div>
                                                        {/* <div className="col">{getWAMessageDetails(aiBupaServiceRecommendations?.[0]?.labs)}</div> */}
                                                        <div className='tw-max-w-fit tw-flex tw-flex-wrap tw-items-center tw-gap-2'>
                                                            {aiBupaServiceRecommendations[0]?.labs?.filter(item => item.matchFound === 'N')?.map((labItem, labIndex) => (
                                                                <React.Fragment key={`lab-${labIndex}`}>
                                                                    <span className="tw-text-xs tw-font-semibold tw-text-[#1279BE] tw-px-2 tw-py-1 tw-bg-white tw-rounded-xl border tw-border-[#1279BE]/50 tw-border-2 tw-whitespace-nowrap">
                                                                        {labItem.serviceDesc + " - Qty: " + labItem.servicelineItemQuantity + " - " + moment(labItem.serviceSupplyTo).format('D MMM, YYYY')}
                                                                    </span>
                                                                </React.Fragment>
                                                            ))}
                                                        </div>
                                                    </div>
                                                }
                                                {(formData.addressType && formData.address) && aiBupaServiceRecommendations[0]?.labs?.filter(item => item.matchFound === 'N')?.length > 0 && (
                                                    <div className='vr tw-bg-gray-400'></div>
                                                )}
                                                {/* {formData.addressType && (formData.address || formData.latitude) &&  */}
                                                {(formData.addressType && formData.address) &&
                                                    <div className="tw-flex tw-flex-col tw-w-fit tw-min-w-fit">
                                                        <span className="tw-mb-1 tw-font-semibold tw-text-lg tw-whitespace-nowrap">Delivery Information</span>
                                                        <LocationDisplay locationData={formData} />
                                                    </div>
                                                }
                                            </div>
                                        )}
                                    {formData.mediaUrl && formData.mediaUrl?.length > 0 &&
                                        <div className="tw-flex tw-flex-col tw-items-start tw-flex-shrink-0 tw-min-w-32 tw-flex-grow profile-box-n1">
                                            <span className="tw-mb-3 -tw-mt-1 fw-semibold tw-text-base" style={{ color: '#212529' }}>
                                                View Original
                                            </span>

                                            <div className="tw-relative mb-1">
                                                <div className="tw-relative tw-inline-block">
                                                    <span
                                                        // disabled={!formData.mediaUrl || formData.mediaUrl.length === 0}
                                                        onClick={toggleDropdown}
                                                        className="tw-py-1.5 tw-px-3 tw-rounded-xl hover:tw-bg-[#1279BE] hover:tw-text-white tw-transition-colors border tw-cursor-pointer tw-inline-block"
                                                    >
                                                        <i className="bi bi-eye"></i>
                                                    </span>
                                                    <span className="tw-absolute tw--top-2 tw--right-2 tw-bg-blue-500 tw-text-white tw-text-xs tw-rounded-full tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-font-semibold">
                                                        {formData.mediaUrl?.length}
                                                    </span>
                                                </div>

                                                {isDropdownOpen && (
                                                    <div className={`tw-absolute tw-top-[calc(100%+5px)] ${aiBupaServiceRecommendations[0]?.medicines?.filter(item => item.matchFound === 'N')?.length > 0 ? 'tw-right-0' : 'tw-left-0'} tw-mt-1 tw-bg-white border tw-rounded-xl tw-overflow-hidden tw-shadow-lg tw-min-w-28 tw-z-50 tw-max-h-48 tw-overflow-y-auto`}>
                                                        {formData.mediaUrl.map((url, index) => (
                                                            <button
                                                                key={index}
                                                                onClick={() => handleImageClick(url)}
                                                                className="tw-w-full tw-px-4 tw-py-2 tw-border-none tw-text-left hover:tw-bg-[#1279BE] hover:tw-text-white tw-transition-colors tw-first:tw-rounded-t-xl tw-last:tw-rounded-b-xl tw-whitespace-nowrap"
                                                            >
                                                                Image {index + 1}
                                                            </button>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Click outside to close dropdown */}
                                            {isDropdownOpen && (
                                                <div
                                                    className="tw-fixed tw-inset-0 tw-z-0"
                                                    onClick={() => setIsDropdownOpen(false)}
                                                />
                                            )}
                                        </div>
                                    }
                                </div>
                                <div className='row'>
                                    <div className='col-md-6 mb-2 mt-2'>
                                        <div className='row'>
                                            <div className='col-md-6 mb-4'>
                                                <label className="form-label">Name
                                                </label>
                                                <h5 className='name-label-field' name="name">{formData['name']}</h5>
                                            </div>

                                            <div className='col-md-6 mb-4'>
                                                <label className="form-label">Membership
                                                </label>
                                                <h5 className='name-label-field' name="membership">{formData['membership']}</h5>
                                            </div>

                                            <div className='col-md-6 mb-3'>
                                                <label className="form-label">Mobile Number
                                                </label>
                                                <input type="text" name="mobileNumber" className='form-control control-input-ui' value={formData['mobileNumber']} onChange={handleChange} />
                                            </div>

                                            <div className='col-md-6 mb-3'>
                                                <label className="form-label">Partner Clinic
                                                    <span className='text-danger'>*</span>
                                                </label>
                                                <select className="form-select select-input-ui" name="partnerClinic" id="partnerClinic" value={formData['partnerClinic']} onChange={handleChange} >
                                                    <option value="">-- Select Partner Clinic --</option>
                                                    {partner.map(option => (
                                                        <option key={option.id} value={option.id}>{option.partnerName}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className='col-md-6 mb-3'>
                                                <label className="form-label">Co-payment
                                                    <span className='text-danger'>*</span>
                                                </label>
                                                <div className='mt-1'>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            name="coPayment"
                                                            id="coPaymentYes"
                                                            value="yes"
                                                            checked={formData.coPayment === 'yes'}
                                                            onChange={handleChange}
                                                            className="form-check-input"
                                                        />
                                                        <label className="form-check-label mt-1" htmlFor="coPaymentYes">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline ps-5">
                                                        <input
                                                            type="radio"
                                                            name="coPayment"
                                                            id="coPaymentNo"
                                                            value="no"
                                                            checked={formData.coPayment === 'no'}
                                                            onChange={handleChange}
                                                            className="form-check-input"
                                                        />
                                                        <label className="form-check-label mt-1" htmlFor="coPaymentNo">No</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-6 mb-3'>
                                                <label className="form-label">Deductible
                                                    <span className='text-danger'>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="deductible"
                                                    className='form-control control-input-ui'
                                                    value={formData['deductible']}
                                                    onChange={handleChange}
                                                    disabled={formData.coPayment === 'no'}
                                                />
                                            </div>

                                            <div className='col-md-6 mb-3'>
                                                <label className="form-label">District</label>
                                                <input type="text" name="district" className='form-control control-input-ui' value={formData['district']} onChange={handleChange} />
                                            </div>

                                            <div className='col-md-6 mb-3'>
                                                <label className="form-label">Nationality
                                                    <span className='text-danger'>*</span>
                                                </label>
                                                <select className="form-select select-input-ui" name="nationality" id="nationality" value={formData['nationality']} onChange={handleChange} >
                                                    <option value="">-- Select Nationality --</option>
                                                    <option value="Indian">Indian</option>
                                                    <option value="Non Indian">Non Indian</option>
                                                </select>
                                            </div>

                                            <div className='col-md-6 mb-3'>
                                                <label className="form-label">City
                                                    <span className='text-danger'>*</span>
                                                </label>
                                                <Select
                                                    value={cityList.find(option => option.label === formData.city) || null}
                                                    onChange={handleChangeCity}
                                                    options={cityList}
                                                    isSearchable={true}
                                                    placeholder="Select City"
                                                    className="form-control select-input-ui select-input-ui-select"
                                                />
                                            </div>


                                            <div className='col-md-6 mb-3'>
                                                <label className="form-label">Lab Provider
                                                    <span className='text-danger'>*</span>
                                                </label>
                                                <select className="form-select select-input-ui" name="labProvider" id="labProvider" value={formData['labProvider']} onChange={handleChange} >
                                                    <option value="">-- Select Lab Provider --</option>
                                                    {labProviderList?.map(option => (
                                                        <option key={option.id} value={option.id}>{option.labName}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-6 mb-3 '>
                                        <div className='row'>

                                            <div className='col-md-12 mb-3'>
                                                <label className="form-label">Remarks
                                                </label>
                                                <input type="text" name="remarks" className='form-control control-input-ui' value={formData['remarks']} onChange={handleChange} />
                                            </div>
                                            <div className='col-md-12 mb-3'>
                                                <label className="form-label">Approval Number
                                                </label>
                                                <input type="text" name="approvalNumber" className='form-control control-input-ui' value={formData['approvalNumber']} onChange={handleChange} />
                                            </div>
                                            <div className='col-md-12 mb-3'>
                                                <label className="form-label">Preferred Appointment Date
                                                    <span className='text-danger'>*</span>
                                                </label>
                                                <div className="date-picker-wrapper" style={{ position: 'relative' }}>
                                                    <DatePicker
                                                        selectsRange={false}
                                                        selected={formData['viewDate']}
                                                        onChange={(date) => setSelctedDate(date)}
                                                        // selected={selectedDate}
                                                        // onChange={handleDateChange}
                                                        showTimeSelect
                                                        timeFormat="h:mm aa"
                                                        timeIntervals={10}
                                                        dateFormat="dd MMMM yyyy, h:mm aa"
                                                        minDate={new Date()}
                                                        filterTime={filterPassedTime}
                                                        // minTime={formData['viewDate'] > new Date() ? new Date(new Date().setHours(0,0,0,0)) : new Date()}
                                                        // maxTime={new Date().setHours(23, 59, 59)}
                                                        placeholderText="Select Date and Time"
                                                        className="form-control input-field-ui"
                                                        isClearable={false}
                                                        onKeyDown={(e) => {
                                                            e.preventDefault();
                                                        }}
                                                    />
                                                    <i className='bx bx-calendar'
                                                        style={{
                                                            position: 'absolute',
                                                            right: '10px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            pointerEvents: 'none',
                                                            fontSize: '20px',
                                                            color: '#666'
                                                        }}></i>
                                                </div>
                                            </div>
                                            <div className='col-md-12 mb-3'>
                                                <label className="form-label">Recommended Services
                                                </label>
                                                <select className="form-select select-input-ui" name="recommendations" id="recommendations" value={selectedRecommendation} onChange={handleRecommendationChange} >
                                                    <option value="">-- Select --</option>
                                                    {
                                                        recommendationsList.map((item, index) => {
                                                            return <option value={index}>{item.title}</option>
                                                        })
                                                    }
                                                </select>

                                            </div>
                                            <div className='col-md-12 mb-3'>
                                                <label className="form-label">Requested Lab Test
                                                    <span className='text-danger'>*</span>(Count:{formData['productCount']})
                                                </label>
                                                {/* <textarea type="text" name="requestedLabTest" className='form-control control-input-ui' style={{ height: "130px" }} rows="7" value={formData['requestedLabTest']} onChange={handleChange}></textarea> */}
                                                <MultiSelect
                                                    options={serviceList}
                                                    value={selectedOptions}
                                                    onChange={handleChangeService}
                                                    labelledBy="Select"
                                                    hasSelectAll={false}
                                                    disableSearch={false}
                                                    overrideStrings={{
                                                        selectAll: 'Select All',
                                                        allItemsAreSelected: 'All items are selected',
                                                        selectSomeItems: 'Select items',
                                                    }}
                                                    className="form-select select-input-ui select-input-ui-select"
                                                    name="requestedLabTest"
                                                    id="requestedLabTest"

                                                />

                                            </div>

                                            <div className='col-md-12 mb-3'>
                                                {selectedUserNamesTemp}
                                            </div>


                                        </div>
                                    </div>
                                    <div className='col-md-12 text-center mt-2'>
                                        <div className={`${error != "" ? "errorDiv" : "hide"}`}>{error}</div>
                                        <div className={`${message != "" ? "messageDiv" : "hide"}`}>{message}</div>
                                        <Button variant="primary" type="submit" className="btn btn-primary save-btn me-3" disabled={disabledButton}>Save Lab Request</Button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default LabRequestMetaDocForms;